module.exports = __webpack_public_path__ + "static/media/icon-people-first.b264095b.svg";